import './design/ripple.js';
import './design/menu.js';
import './design/dialog.js';
import './design/tabs.js';
import './design/snackbar.js';
import './design/progress.js';
import './design/slider.js';
import './design/chips.js';
import './design/drawer.js';
import './design/select.js';
import './design/alert.js';
import './design/pagination.js';
import './design/table-sort.js';
import './design/banner.js';
import './design/appbar.js';
import './design/bottom-sheet.js';
import './design/dropzone.js';
import './design/toast.js';
import './design/popover.js';
import './design/textarea.js';
import './design/theme.js';
import './design/overlay.js';
import './design/form-validate.js';
import './design/avatar.js';
import './design/empty.js';
import './design/stepper.js';
import './design/carousel.js';
import './design/rating.js';
import './design/date-picker.js';
import './design/time-picker.js';
import './design/autocomplete.js';
import './design/tag-input';
import './design/fab-dial';
import './design/nav-rail';
import './design/color-picker';
import './design/tree';
import './design/range-dual';
import './design/table-select';
import './design/appbar-search';

const reviewFilters = document.querySelectorAll('[data-filter]');
const reviewCards = document.querySelectorAll('[data-review-category]');

document.documentElement.classList.add('js-enhanced');

const elevatedHeaders = document.querySelectorAll('.site-header, .dashboard-topbar');
if (elevatedHeaders.length) {
    const refreshHeaderState = () => {
        const isScrolled = window.scrollY > 12;
        elevatedHeaders.forEach((header) => header.classList.toggle('is-scrolled', isScrolled));
    };

    refreshHeaderState();
    document.addEventListener('scroll', refreshHeaderState, { passive: true });
}

const globalRevealItems = document.querySelectorAll([
    '.hero-card',
    '.product-mockup',
    '.product-preview',
    '.info-card',
    '.step-card',
    '.review-card',
    '.dashboard-card',
    '.workspace-company-list__item',
    '.plan-card',
    '.content-card',
    '.content-faq-item',
].join(','));

if (globalRevealItems.length && 'IntersectionObserver' in window) {
    const globalRevealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                return;
            }

            entry.target.classList.add('is-visible');
            globalRevealObserver.unobserve(entry.target);
        });
    }, {
        threshold: 0.12,
        rootMargin: '0px 0px -48px 0px',
    });

    globalRevealItems.forEach((item, index) => {
        item.classList.add('reveal-card');
        item.style.setProperty('--reveal-delay', `${Math.min(index % 6, 5) * 42}ms`);
        globalRevealObserver.observe(item);
    });
}

if (reviewFilters.length && reviewCards.length) {
    reviewFilters.forEach((button) => {
        button.addEventListener('click', () => {
            const filter = button.dataset.filter || 'all';

            reviewFilters.forEach((item) => item.classList.remove('is-active'));
            button.classList.add('is-active');

            reviewCards.forEach((card) => {
                const category = card.dataset.reviewCategory || '';
                const show = filter === 'all' || category === filter;
                card.classList.toggle('is-hidden', !show);
                card.classList.toggle('is-visible', show);
            });
        });
    });
}

const authRoot = document.querySelector('[data-admin-auth]');

if (authRoot) {
    const toggle = authRoot.querySelector('.pro-space__toggle');
    const panel = authRoot.querySelector('.pro-space__panel');
    const firstInput = authRoot.querySelector('input[name="pseudo"]');

    const setOpen = (open) => {
        authRoot.classList.toggle('is-open', open);
        panel?.classList.toggle('is-open', open);
        panel?.setAttribute('aria-hidden', open ? 'false' : 'true');
        toggle?.setAttribute('aria-expanded', open ? 'true' : 'false');

        if (open) {
            window.requestAnimationFrame(() => firstInput?.focus());
        }
    };

    const initialOpen = authRoot.dataset.initialOpen === 'true';
    setOpen(initialOpen);

    toggle?.addEventListener('click', (event) => {
        event.preventDefault();
        setOpen(!authRoot.classList.contains('is-open'));
    });

    document.addEventListener('click', (event) => {
        if (!authRoot.contains(event.target)) {
            setOpen(false);
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            setOpen(false);
        }
    });
}


const contentPageRoots = document.querySelectorAll('[data-content-page]');

contentPageRoots.forEach((root) => {
    const navButtons = Array.from(root.querySelectorAll('[data-scroll-target]'));
    const sections = Array.from(root.querySelectorAll('[data-page-section]'));
    const revealCards = root.querySelectorAll('.reveal-card');
    const faqItems = root.querySelectorAll('[data-page-faq] details');

    navButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const targetId = button.dataset.scrollTarget;
            const target = targetId ? root.querySelector(`#${targetId}`) : null;
            target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    });

    faqItems.forEach((item) => {
        item.addEventListener('toggle', () => {
            if (!item.open) {
                return;
            }

            faqItems.forEach((other) => {
                if (other !== item) {
                    other.open = false;
                }
            });
        });
    });

    if (revealCards.length) {
        const revealObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                }
            });
        }, {
            threshold: 0.18,
            rootMargin: '0px 0px -40px 0px',
        });

        revealCards.forEach((card) => revealObserver.observe(card));
    }

    if (navButtons.length && sections.length) {
        const syncActiveButton = () => {
            const current = sections.find((section) => {
                const rect = section.getBoundingClientRect();
                return rect.top <= 160 && rect.bottom >= 160;
            }) || sections[0];

            const currentId = current?.id || '';
            navButtons.forEach((button) => {
                button.classList.toggle('is-active', button.dataset.scrollTarget === currentId);
            });
        };

        syncActiveButton();
        document.addEventListener('scroll', syncActiveButton, { passive: true });
    }
});

const onboardingWizard = document.querySelector('[data-pro-onboarding-wizard]');

if (onboardingWizard) {
    const storageKey = 'startlegal:onboarding-wizard';
    const memoryStorage = new Map();
    const stepPanels = Array.from(onboardingWizard.querySelectorAll('[data-step-panel]'));
    const stepItems = Array.from(onboardingWizard.querySelectorAll('[data-step-list] li'));
    const stepTitle = onboardingWizard.querySelector('[data-step-title]');
    const stepPercent = onboardingWizard.querySelector('[data-step-percent]');
    const progressBar = onboardingWizard.querySelector('[data-step-progress]');
    const progressFill = onboardingWizard.querySelector('[data-step-progress-fill]');
    const prevButton = onboardingWizard.querySelector('[data-step-prev]');
    const nextButton = onboardingWizard.querySelector('[data-step-next]');
    const submitButton = onboardingWizard.querySelector('[data-step-submit]');
    const conditionalBlocks = Array.from(onboardingWizard.querySelectorAll('[data-conditional-field]'));
    const managersAccordion = onboardingWizard.querySelector('[data-managers-accordion]');
    const managersList = onboardingWizard.querySelector('[data-managers-list]');
    const managerTemplate = onboardingWizard.querySelector('[data-manager-template]');
    const addManagerButton = onboardingWizard.querySelector('[data-add-manager]');
    const activitiesSection = onboardingWizard.querySelector('#establishment-activities-section');
    const activitiesList = onboardingWizard.querySelector('#establishment-activities-list');
    const addActivityButton = onboardingWizard.querySelector('#add-establishment-activity');
    const activityFormPanel = onboardingWizard.querySelector('#establishment-activity-form-panel');
    const additionalAttachmentInput = onboardingWizard.querySelector('#additional-attachment-files');
    const additionalAttachmentTriggers = Array.from(onboardingWizard.querySelectorAll('[data-additional-attachment-trigger]'));
    const fileFields = Array.from(onboardingWizard.querySelectorAll('input[type="file"]'));
    const fields = Array.from(onboardingWizard.querySelectorAll('input[name], select[name], textarea[name]'))
        .filter((field) => field.type !== 'file' && field.type !== 'hidden');
    const summaryFields = Array.from(onboardingWizard.querySelectorAll('[data-summary-field]'));
    const totalSteps = stepPanels.length;
    const focusAliases = {
        manager_name: 'manager_fullname',
        beneficial_owner: 'beneficial_owner_first_name',
        beneficial_owner_fullname: 'beneficial_owner_first_name',
        beneficial_owner_share: 'beneficial_owner_capital_percentage',
        capital: 'share_capital',
    };
    const rawFocusField = (onboardingWizard.dataset.focusField || '').trim();
    const focusField = focusAliases[rawFocusField] || rawFocusField;
    const activityFields = [
        'is_primary',
        'start_date',
        'exercise_type',
        'is_ambulatory',
        'is_agricultural_extension',
        'description',
        'category_1',
        'category_2',
        'category_3',
        'origin_type',
    ];

    const safeParse = (value) => {
        try {
            return JSON.parse(value);
        } catch (error) {
            return null;
        }
    };

    const readWizardState = () => {
        try {
            return window.localStorage.getItem(storageKey);
        } catch (error) {
            return memoryStorage.get(storageKey) || null;
        }
    };

    const writeWizardState = (value) => {
        memoryStorage.set(storageKey, value);
        try {
            window.localStorage.setItem(storageKey, value);
        } catch (error) {
            // localStorage can be unavailable (privacy settings, blocked storage).
        }
    };

    const clearWizardState = () => {
        memoryStorage.delete(storageKey);
        try {
            window.localStorage.removeItem(storageKey);
        } catch (error) {
            // localStorage can be unavailable (privacy settings, blocked storage).
        }
    };

    if (onboardingWizard.dataset.resetWizard === 'true') {
        clearWizardState();
    }

    const storedState = safeParse(readWizardState() || '');
    const storedStep = Number.isInteger(storedState?.step) ? Math.min(Math.max(storedState.step, 0), totalSteps - 1) : 0;
    const storedMaxStep = Number.isInteger(storedState?.max_step_reached)
        ? Math.min(Math.max(storedState.max_step_reached, 0), totalSteps - 1)
        : storedStep;
    let currentStep = Math.max(storedStep, storedMaxStep);
    let maxStepReached = Math.max(storedStep, storedMaxStep);
    if (onboardingWizard.dataset.allowAllSteps === 'true') {
        maxStepReached = totalSteps - 1;
    }
    const selectedPlanField = onboardingWizard.querySelector('input[name="selected_plan"]:checked');
    const initialSelectedPlanValue = selectedPlanField?.value || '';
    let isSubmittingForm = false;
    let autoDraftSent = false;

    if (storedState?.values && typeof storedState.values === 'object') {
        fields.forEach((field) => {
            const savedValue = storedState.values[field.name];
            if (typeof savedValue !== 'string') {
                return;
            }

            if (field.type === 'checkbox') {
                field.checked = savedValue === 'true';
                return;
            }

            if (field.type === 'radio') {
                field.checked = savedValue === field.value;
                return;
            }

            field.value = savedValue;
        });
    }

    if (initialSelectedPlanValue && !onboardingWizard.querySelector('input[name="selected_plan"]:checked')) {
        const initialPlanInput = onboardingWizard.querySelector(`input[name="selected_plan"][value="${initialSelectedPlanValue}"]`);
        if (initialPlanInput instanceof HTMLInputElement) {
            initialPlanInput.checked = true;
        }
    }

    const saveState = () => {
        const values = {};
        fields.forEach((field) => {
            if (field.type === 'checkbox') {
                values[field.name] = field.checked ? 'true' : 'false';
                return;
            }

            if (field.type === 'radio') {
                if (field.checked) {
                    values[field.name] = field.value;
                    return;
                }

                if (!(field.name in values)) {
                    values[field.name] = '';
                }
                return;
            }

            values[field.name] = field.value;
        });

        writeWizardState(JSON.stringify({
            step: currentStep,
            max_step_reached: maxStepReached,
            values,
        }));
    };

    const shouldIncludeAutoDraftField = (field) => {
        if (!field.name || field.type === 'file') {
            return false;
        }

        if (field.type === 'checkbox' || field.type === 'radio') {
            return field.checked;
        }

        return true;
    };

    const hasDraftContent = () => {
        return Array.from(onboardingWizard.querySelectorAll('input[name], select[name], textarea[name]'))
            .some((field) => {
                const ignoredFieldNames = ['focus_field', 'save_as_draft', 'auto_draft', 'return_to_workspace'];
                if (!field.name || field.type === 'file' || ignoredFieldNames.includes(field.name)) {
                    return false;
                }

                if (field.type === 'checkbox' || field.type === 'radio') {
                    return field.checked;
                }

                return String(field.value || '').trim() !== '';
            });
    };

    const buildAutoDraftPayload = () => {
        const payload = new URLSearchParams();
        onboardingWizard.querySelectorAll('input[name], select[name], textarea[name]').forEach((field) => {
            if (!shouldIncludeAutoDraftField(field)) {
                return;
            }

            payload.append(field.name, field.value);
        });
        payload.set('save_as_draft', '1');
        payload.set('auto_draft', '1');
        return payload;
    };

    const sendAutoDraft = () => {
        if (isSubmittingForm || autoDraftSent || !hasDraftContent()) {
            return;
        }

        autoDraftSent = true;
        saveState();
        const payload = buildAutoDraftPayload();
        const body = new Blob([payload.toString()], { type: 'application/x-www-form-urlencoded;charset=UTF-8' });
        const action = onboardingWizard.getAttribute('action') || window.location.pathname;

        if (navigator.sendBeacon && navigator.sendBeacon(action, body)) {
            return;
        }

        fetch(action, {
            method: 'POST',
            body: payload,
            keepalive: true,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            },
        }).catch(() => {
            // The page is unloading; the local wizard state remains as a fallback.
        });
    };

    const stepFields = (index) => {
        const panel = stepPanels[index];
        if (!panel) {
            return [];
        }

        return Array.from(panel.querySelectorAll('input, select, textarea')).filter((field) => !field.disabled);
    };

    const refreshFileFieldState = (field) => {
        const hasFile = field instanceof HTMLInputElement && field.files && field.files.length > 0;
        field.classList.toggle('is-filled', hasFile);
    };

    const focusTargetField = () => {
        if (!focusField) {
            return;
        }

        const target = onboardingWizard.querySelector(`[name="${CSS.escape(focusField)}"]`);
        if (!target) {
            return;
        }

        target.classList.add('is-invalid');
        target.classList.add('is-highlighted-field');
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        target.focus({ preventScroll: true });
    };

    stepItems.forEach((item, index) => {
        item.dataset.stepIndex = String(index);
        item.addEventListener('click', () => {
            if (index <= maxStepReached) {
                setStep(index);
            }
        });
    });

    const refreshConditionalFields = () => {
        conditionalBlocks.forEach((block) => {
            const triggerName = block.dataset.conditionalWhenField || '';
            const allowedValues = (block.dataset.conditionalWhenValue || '')
                .split(',')
                .map((value) => value.trim())
                .filter(Boolean);
            const triggerField = onboardingWizard.querySelector(`[name="${triggerName}"]`);
            const checkedTriggerField = onboardingWizard.querySelector(`[name="${triggerName}"]:checked`);
            let triggerValue = '';
            if (triggerField?.type === 'checkbox') {
                triggerValue = checkedTriggerField ? String(checkedTriggerField.value || '').trim() : '';
            } else {
                triggerValue = ((checkedTriggerField || triggerField)?.value || '').trim();
            }
            const shouldShow = triggerField !== null && allowedValues.includes(triggerValue);

            block.hidden = !shouldShow;
            block.style.display = shouldShow ? '' : 'none';

            block.querySelectorAll('input, select, textarea').forEach((field) => {
                if (!field.dataset.conditionalRequired) {
                    field.dataset.conditionalRequired = field.required ? 'true' : 'false';
                }
                const hadConditionalRequired = field.dataset.conditionalRequired === 'true';

                field.required = shouldShow && hadConditionalRequired;

                if (!shouldShow) {
                    if (field.type === 'radio' || field.type === 'checkbox') {
                        field.checked = false;
                        return;
                    }
                    field.value = '';
                }
            });
        });
    };

    const activityFormFields = () => {
        return activityFormPanel ? Array.from(activityFormPanel.querySelectorAll('input, select, textarea')) : [];
    };

    const refreshActivityFormState = () => {
        if (!activityFormPanel) {
            return;
        }

        const isOpen = !activityFormPanel.hidden;
        activityFormFields().forEach((field) => {
            field.disabled = !isOpen;
        });
    };

    const resetActivityForm = () => {
        activityFormFields().forEach((field) => {
            if (field.type === 'radio' || field.type === 'checkbox') {
                field.checked = false;
                return;
            }

            field.value = '';
        });
    };

    const openActivityForm = () => {
        if (!activityFormPanel) {
            return;
        }

        activityFormPanel.hidden = false;
        activityFormPanel.style.display = '';
        refreshActivityFormState();
        activityFormPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        const firstField = activityFormPanel.querySelector('input, select, textarea');
        firstField?.focus({ preventScroll: true });
    };

    const closeActivityForm = () => {
        if (!activityFormPanel) {
            return;
        }

        resetActivityForm();
        activityFormPanel.hidden = true;
        activityFormPanel.style.display = 'none';
        refreshActivityFormState();
    };

    const activityCards = () => activitiesList ? Array.from(activitiesList.querySelectorAll('[data-establishment-activity-item]')) : [];
    const activityCount = () => activityCards().length;

    const refreshActivityIndexes = () => {
        activityCards().forEach((card, index) => {
            card.querySelectorAll('[data-activity-hidden-field]').forEach((field) => {
                const fieldName = field.dataset.activityHiddenField || '';
                field.name = `establishment_activities[${index}][${fieldName}]`;
            });
        });
    };

    const readActivityForm = () => {
        const activity = {};
        activityFields.forEach((fieldName) => {
            const checkedField = activityFormPanel?.querySelector(`[data-activity-field="${fieldName}"]:checked`);
            const field = checkedField || activityFormPanel?.querySelector(`[data-activity-field="${fieldName}"]`);
            activity[fieldName] = String(field?.value || '').trim();
        });
        return activity;
    };

    const addActivityToList = (activity) => {
        if (!activitiesList) {
            return;
        }

        const item = document.createElement('article');
        item.className = 'establishment-activity-item';
        item.dataset.establishmentActivityItem = '';

        const content = document.createElement('div');
        content.className = 'establishment-activity-item__content';

        const title = document.createElement('strong');
        title.textContent = activity.category_3 || activity.category_2 || activity.category_1 || 'Activité de l’établissement';
        content.append(title);

        if (activity.description) {
            const descriptionLabel = document.createElement('span');
            descriptionLabel.textContent = activity.description;
            content.append(descriptionLabel);
        }

        if (activity.is_primary === 'oui') {
            const primaryLabel = document.createElement('span');
            primaryLabel.textContent = 'Activité principale';
            content.append(primaryLabel);
        }

        item.append(content);

        activityFields.forEach((fieldName) => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.dataset.activityHiddenField = fieldName;
            input.value = activity[fieldName] || '';
            item.append(input);
        });

        const removeButton = document.createElement('button');
        removeButton.type = 'button';
        removeButton.className = 'btn btn-secondary';
        removeButton.dataset.removeEstablishmentActivity = '';
        removeButton.textContent = 'Effacer';
        item.append(removeButton);

        activitiesList.append(item);
        refreshActivityIndexes();
        addActivityButton?.setCustomValidity('');
        saveState();
    };

    const validateActivityCountForCurrentStep = () => {
        if (!activitiesSection || !stepPanels[currentStep]?.contains(activitiesSection) || activityCount() > 0) {
            addActivityButton?.setCustomValidity('');
            return true;
        }

        addActivityButton?.setCustomValidity('Merci d’ajouter au moins une activité de l’établissement.');
        addActivityButton?.reportValidity();
        return false;
    };

    const fieldDisplayValue = (name) => {
        const matchingFields = Array.from(onboardingWizard.querySelectorAll(`[name="${CSS.escape(name)}"]`));
        if (!matchingFields.length) {
            return '';
        }

        const firstField = matchingFields[0];
        if (firstField.type === 'radio') {
            const checkedField = matchingFields.find((field) => field.checked);
            return checkedField ? String(checkedField.value || '').trim() : '';
        }

        if (firstField.type === 'checkbox') {
            const checkedValues = matchingFields
                .filter((field) => field.checked)
                .map((field) => String(field.value || '').trim())
                .filter(Boolean);
            return checkedValues.join(', ');
        }

        if (firstField instanceof HTMLSelectElement) {
            const selectedOption = firstField.selectedOptions[0];
            const value = String(firstField.value || '').trim();
            return value ? String(selectedOption?.textContent || value).trim() : '';
        }

        return String(firstField.value || '').trim();
    };

    const refreshSummary = () => {
        summaryFields.forEach((item) => {
            const fieldName = item.dataset.summaryField || '';
            const value = fieldDisplayValue(fieldName);
            item.textContent = value || 'Non renseigné';
        });
    };

    const setStep = (nextStep) => {
        currentStep = Math.min(Math.max(nextStep, 0), totalSteps - 1);
        maxStepReached = Math.max(maxStepReached, currentStep);
        const progressValue = Math.round(((maxStepReached + 1) / totalSteps) * 100);
        const activeStepName = stepPanels[currentStep]?.dataset.stepName || `Étape ${currentStep + 1}`;

        stepPanels.forEach((panel, index) => {
            const isActive = index === currentStep;
            panel.hidden = !isActive;
            panel.classList.toggle('is-active', isActive);
            panel.querySelectorAll('input, select, textarea').forEach((field) => {
                if (field.type === 'file') {
                    field.disabled = false;
                    return;
                }

                field.disabled = !isActive;
            });
        });

        refreshConditionalFields();
        refreshActivityFormState();
        refreshSummary();

        stepItems.forEach((item, index) => {
            item.classList.toggle('is-done', index < maxStepReached);
            item.classList.toggle('is-active', index === currentStep);
            const isReachable = index <= maxStepReached;
            item.classList.toggle('is-clickable', isReachable);
            item.setAttribute('aria-disabled', isReachable ? 'false' : 'true');
        });

        prevButton.disabled = false;
        if (prevButton) {
            prevButton.textContent = 'Retour';
        }
        nextButton.hidden = currentStep >= totalSteps - 1;
        submitButton.hidden = currentStep < totalSteps - 1;
        stepTitle.textContent = `Étape ${currentStep + 1} sur ${totalSteps} · ${activeStepName}`;
        stepPercent.textContent = `${progressValue}%`;
        progressBar.setAttribute('aria-valuenow', String(progressValue));
        progressFill.style.width = `${progressValue}%`;
        saveState();
    };

    const managerCards = () => managersList ? Array.from(managersList.querySelectorAll('details')) : [];
    const managerCount = () => managerCards().length;

    const refreshManagerLabels = () => {
        managerCards().forEach((card, index) => {
            const summary = card.querySelector('summary');
            if (summary) {
                summary.textContent = `Dirigeant supplémentaire #${index + 1}`;
            }
        });
    };

    const addManager = () => {
        if (!managersList || !managerTemplate) {
            return;
        }

        const index = managerCount();
        const html = managerTemplate.innerHTML
            .replaceAll('__INDEX__', String(index))
            .replaceAll('__LABEL__', String(index + 1));
        managersList.insertAdjacentHTML('beforeend', html);
        refreshManagerLabels();
    };

    nextButton?.addEventListener('click', () => {
        refreshConditionalFields();
        if (!validateActivityCountForCurrentStep()) {
            return;
        }

        const visibleFields = stepFields(currentStep);
        const isStepValid = visibleFields.every((field) => field.checkValidity());

        if (!isStepValid) {
            onboardingWizard.reportValidity();
            return;
        }

        setStep(currentStep + 1);
    });

    const goPreviousStep = () => {
        if (currentStep > 0) {
            setStep(currentStep - 1);
            return;
        }

        window.location.href = '/espace-pro/offres';
    };

    prevButton?.addEventListener('click', (event) => {
        event.preventDefault();
        goPreviousStep();
    });

    addManagerButton?.addEventListener('click', () => {
        addManager();
    });

    managersAccordion?.addEventListener('click', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLElement) || !target.closest('[data-remove-manager]')) {
            return;
        }

        event.preventDefault();
        const details = target.closest('details');
        details?.remove();
        refreshManagerLabels();
        saveState();
    });

    addActivityButton?.addEventListener('click', () => {
        openActivityForm();
    });

    activityFormPanel?.querySelector('[data-cancel-establishment-activity]')?.addEventListener('click', () => {
        closeActivityForm();
    });

    activityFormPanel?.querySelector('[data-save-establishment-activity]')?.addEventListener('click', () => {
        refreshActivityFormState();
        const invalidField = activityFormFields().find((field) => !field.checkValidity());
        if (invalidField) {
            invalidField.reportValidity();
            return;
        }

        addActivityToList(readActivityForm());
        closeActivityForm();
    });

    activitiesList?.addEventListener('click', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLElement) || !target.closest('[data-remove-establishment-activity]')) {
            return;
        }

        event.preventDefault();
        target.closest('[data-establishment-activity-item]')?.remove();
        refreshActivityIndexes();
        validateActivityCountForCurrentStep();
        saveState();
    });

    additionalAttachmentTriggers.forEach((button) => {
        button.addEventListener('click', () => {
            additionalAttachmentInput?.click();
        });
    });

    fields.forEach((field) => {
        field.addEventListener('input', saveState);
        field.addEventListener('input', refreshSummary);
        field.addEventListener('change', saveState);
        field.addEventListener('change', refreshSummary);
        field.addEventListener('change', refreshConditionalFields);
    });

    fileFields.forEach((field) => {
        refreshFileFieldState(field);
        field.addEventListener('change', () => {
            refreshFileFieldState(field);
        });
    });

    onboardingWizard.addEventListener('submit', () => {
        isSubmittingForm = true;
        stepPanels.forEach((panel) => {
            panel.querySelectorAll('input, select, textarea').forEach((field) => {
                field.disabled = false;
            });
        });
        refreshActivityFormState();
    });

    window.addEventListener('pagehide', sendAutoDraft);
    window.addEventListener('beforeunload', sendAutoDraft);

    if (focusField) {
        const target = onboardingWizard.querySelector(`[name="${CSS.escape(focusField)}"]`);
        const targetPanel = target?.closest('[data-step-panel]');
        if (targetPanel) {
            const targetIndex = stepPanels.findIndex((panel) => panel === targetPanel);
            if (targetIndex >= 0) {
                currentStep = targetIndex;
                maxStepReached = Math.max(maxStepReached, targetIndex);
            }
        }
    }

    refreshConditionalFields();
    refreshSummary();
    setStep(currentStep);

    if (focusField) {
        window.requestAnimationFrame(() => {
            focusTargetField();
            setTimeout(focusTargetField, 250);
        });
    }
}
